import { render, staticRenderFns } from "./ArcoscanIframe.vue?vue&type=template&id=5674e4d4&"
import script from "./ArcoscanIframe.vue?vue&type=script&lang=js&"
export * from "./ArcoscanIframe.vue?vue&type=script&lang=js&"
import style0 from "./ArcoscanIframe.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})
